import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import dayjs from 'dayjs';
import { map, Observable, timer } from 'rxjs';

@Component({
  selector: 'time-before',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './time-before.component.html',
  styleUrl: './time-before.component.css',
})
export class TimeBeforeComponent {
  @Input() dateValue: any;
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' = 'xs';
  timeAgo$!: Observable<string>;

  ngOnInit() {
    // timer(delay, interval)
    // This starts immediately (0) and runs every 60,000ms (1 minute)
    this.timeAgo$ = timer(0, 60000).pipe(
      map(() => this.getTimeAgo(this.dateValue)),
    );
  }

  getTimeAgo(value: any): string {
    if (!value) return 'Date Time Not Known';
    const dateValue = dayjs(value);
    const now = dayjs();
    if (!dateValue.isValid()) return 'Invalid Date';
    const minDiff = now.diff(dateValue, 'minutes');
    if (minDiff < 1) return 'just now';
    if (minDiff < 60) return `${minDiff}m ago`;

    const hourDiff = now.diff(dateValue, 'hours');
    if (hourDiff < 24) return `${hourDiff}h ago`;

    const dayDiff = now.diff(dateValue, 'days');
    const monthDiff = now.diff(dateValue, 'months');

    if (monthDiff < 1) {
      return `${dayDiff}d ago`;
    }

    const dateAfterMonths = dateValue.add(monthDiff, 'months');
    const remainingDays = now.diff(dateAfterMonths, 'days');

    const monthsStr = monthDiff === 1 ? '1 mth' : `${monthDiff} mths`;
    const daysStr = remainingDays > 0 ? (remainingDays === 1 ? '1 day' : `${remainingDays} days`) : '';

    if (daysStr) {
      return `${monthsStr} ${daysStr} ago`;
    }
    return `${monthsStr} ago`;
  }
}
